import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import '../assets/images/webp/aelogo.webp';

const Header = ({ isAuthenticated, user, handleLogout }) => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);

  const apiUploadRootPath = process.env.REACT_APP_FOR_UPLOADS_URL;

const toggleMenu = () => {
  setIsMenuOpen((prev) => {
    const newState = !prev;
    if (newState) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
    return newState;
  });

  setIsNotificationOpen(false);
  setProfileOpen(false);
};

  

  const toggleProfile = () => {
    setProfileOpen((prev) => !prev);
    setIsMenuOpen(false);
    setIsNotificationOpen(false);
  };

  const toggleNotification = () => {
    setIsNotificationOpen((prev) => !prev);
    setIsMenuOpen(false);
    setProfileOpen(false);
  };

  return (
    <header className="header fixed-top">
      <nav className="navbar">
        <div className="logo-section">
          <Link to="/" className="brand">
            <img src="/aelogo.png" alt="Admissions Express logo" className="logo-img" />
            <span className="logo-text">AdmissionsExpress</span>
          </Link>
        </div>

        <div className="nav-sections">
          {/* Hamburger menu for mobile */}
         <div className="hamburger" onClick={toggleMenu}>
  ☰
</div>
    

          {/* Mobile sidebar nav */}
          {isMenuOpen && (
  <div className="mobile-sidebar">
    <button className="close-sidebar" onClick={toggleMenu}>×</button>
    <ul className="mobile-nav-list">
      <li><a href="/#home">Home</a></li>
      <li><a href="/#aboutus">About Us</a></li>
      <li><a href="/blog">Blog</a></li>
      <li><a href="/#ourservices">Services</a></li>
      <li><a href="/#contact">Contact Us</a></li>
      {isAuthenticated && (
        <>
          <li><Link to="/dashboard">Dashboard</Link></li>
          {user?.role === 'admin' && (
            <>
              <li><Link to="/admin">Blog Management</Link></li>
              <li><Link to="/bulk-email">Bulk Email</Link></li>
              <li>
                <a href={`${apiUploadRootPath}/admin`} target="_blank" rel="noopener noreferrer">
                  Admin Panel
                </a>
              </li>
            </>
          )}
        </>
      )}
    </ul>
  </div>
)}


          {/* Desktop links */}
          <ul className="nav-links">
            <li><a href="/#home">Home</a></li>
            <li><a href="/#aboutus">About Us</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/#ourservices">Services</a></li>
            <li><a href="/#contact">Contact Us</a></li>
          </ul>

          {isAuthenticated && user ? (
            <>
              <div className="nav-links">
                <Link to="/dashboard" className="nav-item">
                  <i className="fas fa-home"></i>
                  <span>Dashboard</span>
                </Link>
                {user?.role === 'admin' && (
                  <>
                    <Link to="/admin" className="nav-item">
                      <i className="fas fa-shield-alt"></i>
                      <span>Blog Management</span>
                    </Link>
                    <Link to="/bulk-email" className="nav-item">
                      <i className="fas fa-shield-alt"></i>
                      <span>Bulk Email</span>
                    </Link>
                    <Link to={`${apiUploadRootPath}/admin`} className="nav-item" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-shield-alt"></i>
                      <span>Admin Panel</span>
                    </Link>
                  </>
                )}
              </div>

              <div className="user-controls">
                {/* Notifications */}
                <div className="notification-center" onClick={toggleNotification}>
                  <i className="fas fa-bell"></i>
                  {isNotificationOpen && (
                    <div className="notification-dropdown show">
                      <div className="dropdown-title">Notifications</div>
                      <div className="notification-item">🎉 Thanks for completing your profile!</div>
                      <div className="notification-item">📅 Book an appointment and start your journey!</div>
                    </div>
                  )}
                </div>

                {/* Profile Dropdown */}
                <div className="user-profile">
                  <div className="user-avatar" onClick={toggleProfile}>
                    {user?.name?.charAt(0).toUpperCase()}
                  </div>
                  {isProfileOpen && (
                    <div className="user-dropdown">
                      <div className="user-info">
                        <span className="user-name">{user.name}</span>
                        <span className="user-email">{user.email}</span>
                      </div>
                      <div className="dropdown-content">
                        <Link to="/dashboard" className="dropdown-item">
                          <i className="fas fa-home"></i> My Dashboard
                        </Link>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            document.querySelector('[data-tab="profile"]')?.click();
                          }}
                        >
                          <i className="fas fa-user-cog"></i> Profile Settings
                        </button>
                        <div className="dropdown-divider"></div>
                        <button onClick={handleLogout} className="dropdown-item logout">
                          <i className="fas fa-sign-out-alt"></i> Logout
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="auth-controls">
              <Link to="/auth" className="auth-btn login">Sign In</Link>
              <Link to="/auth" className="auth-btn register">Get Started</Link>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
